module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lte-tabset nav-tabs-custom"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    class: {
      'pull-right': _vm.direction === 'right'
    }
  }, [_vm._l((_vm.tabItems), function(item) {
    return _c('li', {
      class: {
        active: _vm.innerValue === item.name
      },
      on: {
        "click": function($event) {
          _vm.changeTab(item)
        }
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      }
    }, [_c('i', {
      class: item.icon
    }), _vm._v("  " + _vm._s(item.header) + " "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.closable),
        expression: "item.closable"
      }],
      staticClass: "fa fa-close",
      on: {
        "click": function($event) {
          _vm.removeTabItem(item)
        }
      }
    })])])
  }), _vm._v(" "), _vm._t("tabset-tools")], 2), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6afab827","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabset/tabset.vue
// module id = 30
// module chunks = 0